import { createUseStyles } from 'react-jss';
import { DefaultProps } from './Radio';
import { findColor } from '../../theme';
// Styles
const useRadioStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'fit-content'
    },
    radioButtonBase: {
        margin: 0,
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        border: `1px solid ${theme.colors.grey[2]}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    enabled: {
        transition: 'all 0.3s ease',
        '& .RadioButtonInput:checked': {
            border: ({ color }) => `1px solid ${findColor(color || DefaultProps.color, theme)}`
        },
        '& .RadioButtonInput:checked + .RadioButtonCheckmark': {
            opacity: 1
        },
        '&:hover': {
            cursor: 'pointer',
            border: ({ color }) => `1px solid ${findColor(color || DefaultProps.color, theme)}`
        }
    },
    disabled: {
        backgroundColor: theme.colors.grey[5],
        cursor: 'not-allowed'
    },
    checked: {
        border: ({ color }) => `1px solid ${findColor(color || DefaultProps.color, theme)}`
    },
    input: { margin: 0, display: 'none' },
    checkmark: {
        opacity: 0,
        transition: 'opacity 0.3s ease',
        backgroundColor: ({ color }) => findColor(color || DefaultProps.color, theme),
        width: '12px',
        height: '12px',
        borderRadius: '50%'
    },
    label: {
        marginLeft: '8px',
        fontSize: ({ width }) => (width === 'xl' ? '16px' : '14px'),
        color: ({ disabled, color }) => disabled
            ? theme.colors.grey[2]
            : findColor(color || DefaultProps.color, theme)
    }
}));
export default useRadioStyles;
